module.exports = __webpack_public_path__ + "img/allegro_light_grey1.3d1c0026.jpg";